import OrderConfirmationBillingInformation, { orderConfirmationBillingInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationBillingInformation";
import { orderConfirmationShippingInformationStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationShippingInformation";
import { headerStyles } from '@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationHeader';
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";
import { orderConfirmationPageContainerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationPageContainer";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { GridOffset } from "@insite/mobius/GridContainer";

orderConfirmationPageContainerStyles.headerGridItem = {
    css: css`
        order: 1;
        padding-bottom: 0;
    `,
    width: 12,
}

headerStyles.titleGridItem = {
    width: [10, 10, 10, 6, 6],
    css: css`
    padding-bottom: 0;
    `
}

headerStyles.buttonGridItem = {
    width: [2, 2, 2, 6, 6],
    css: css`
    padding-bottom: 0;
    justify-content: flex-end;
    `
}

headerStyles.title = {
    variant: "h1",
    css: css`
    margin-bottom: 0px;
    `
}

orderConfirmationBillingInformationStyles.billingInformationTitleGridItem = {
    width: 12,
    css: css`
        padding: 10px;
        background-color: ${getColor("info.contrast")};
        margin-bottom: 5px !important;
    `
}

orderConfirmationBillingInformationStyles.billingInformationTitle = {
    variant: "h5",
    css: css`
        @media print {
            font-size: 15px;
        }
        padding-top: 0;
        margin-bottom: 0;
    `,
}

orderConfirmationBillingInformationStyles.billingAddressTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}

orderConfirmationBillingInformationStyles.billingCreditCardAddressTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}

orderConfirmationShippingInformationStyles.shippingInformationTitleGridItem = {
    width: 12,
    css: css`
        padding: 10px;
        background-color: ${getColor("info.contrast")};
        margin-bottom: 5px !important;
    `
}

orderConfirmationShippingInformationStyles.shippingInformationGridContainer = {
    gap: 10,
    css: css`
    >${GridOffset}{
        width: 100%;
        margin: 0;
    }
    `
}

orderConfirmationBillingInformationStyles.billingInformationGridContainer = {
    gap: 10,
    css: css`
    >${GridOffset}{
        width: 100%;
        margin: 0;
    }
    `
}

orderConfirmationShippingInformationStyles.shippingInformationTitle = {
    variant: "h5",
    css: css`
        @media print {
            font-size: 15px;
        }
        padding-top: 0;
        margin-bottom: 0;
    `,
}

orderConfirmationShippingInformationStyles.shippingAddressTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}

orderConfirmationShippingInformationStyles.shippingCarrierTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}

orderConfirmationShippingInformationStyles.shippingDateRequestedTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}

orderConfirmationShippingInformationStyles.shippingServiceTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}

orderConfirmationShippingInformationStyles.shippingPoNumberTitle = {
    variant: "h6",
    css: css`
        @media print {
            font-size: 12px;
        }
        margin-bottom: 5px;
    `,
}

orderConfirmationShippingInformationStyles.shippingInformationAddressGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        flex-direction: column;
        padding-left: 10px;
        >address[class^="sc"]{
            >${TypographyStyle}{
                color: ${getColor("secondary")};
            }
        }
    `,
}

orderConfirmationBillingInformationStyles.billingInformationBillingAddressGridItem = {
    width: [12, 12, 4, 4, 4],
    printWidth: 4,
    css: css`
        flex-direction: column;
        padding-left: 10px;
        >address[class^="sc"]{
            >${TypographyStyle}{
                color: ${getColor("secondary")};
            }
        }
    `,
}

orderConfirmationShippingInformationStyles.shippingCarrierDescription = {
    css: css`
    color: ${getColor("secondary")};
    `
}

orderConfirmationShippingInformationStyles.shippingInformationCarrierGridItem = {
    css: css`
        flex-direction: column;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                css`
                padding-left: 10px;
                `,
                null,
                null,
                null,
        ],"max",)}
    `,
    width: 6,
}

orderConfirmationShippingInformationStyles.shippingDateRequestedText = {
    css: css`
    color: ${getColor("secondary")};
    `
}

orderConfirmationShippingInformationStyles.shippingServiceDescription = {
    css: css`
    color: ${getColor("secondary")};
    `
}